const CAROUSEL_ITEMS = [
  {
    title: '热血少年漫：燃到停不下来的必看佳作',
    desc: '从鬼灭之刃到咒术回战，从海贼王到我的英雄学院——精选热血少年漫中最燃的篇章。下拉式阅读让战斗场面一气呵成，全屏观看感受最炸裂的视觉冲击。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20manga%20style%20illustration%20of%20multiple%20young%20heroes%20standing%20together%20in%20dynamic%20battle-ready%20poses%2C%20warm%20golden%20sunset%20lighting%20with%20dramatic%20energy%20effects%2C%20Japanese%20anime%20art%20style%2C%20cinematic%20composition%2C%20grand%20scale%2C%20inspirational%20atmosphere&width=1600&height=900&seq=carousel-hero-01&orientation=landscape',
    tag: '热血专题',
  },
  {
    title: '治愈日常番：温暖人心的生活漫画推荐',
    desc: '间谍过家家的温馨家庭日常、跃动青春的青春悸动、夏目友人帐的温柔羁绊——这些治愈系漫画用细腻的笔触描绘平凡生活中的不平凡。无弹窗漫画模式让治愈之旅更加纯粹。',
    img: 'https://readdy.ai/api/search-image?query=Heartwarming%20manga%20style%20illustration%20of%20characters%20enjoying%20peaceful%20daily%20life%20in%20a%20cozy%20neighborhood%20setting%2C%20soft%20warm%20morning%20light%2C%20cream%20and%20peach%20color%20palette%2C%20Japanese%20anime%20art%20style%2C%20gentle%20slice%20of%20life%20atmosphere%2C%20detailed%20background&width=1600&height=900&seq=carousel-hero-02&orientation=landscape',
    tag: '治愈专题',
  },
  {
    title: '悬疑推理漫画：烧脑剧情让你欲罢不能',
    desc: '死亡笔记的智斗博弈、约定的梦幻岛的逃亡计划、怪物中的心理博弈——每一部都是推理漫画的巅峰之作。翻页漫画模式精准控制阅读节奏，让每一次反转都恰到好处。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20manga%20style%20illustration%20of%20a%20shadowy%20figure%20in%20a%20library%20filled%20with%20clues%20and%20mysterious%20documents%2C%20atmospheric%20warm%20amber%20lighting%2C%20noir-inspired%20composition%2C%20Japanese%20anime%20art%20style%2C%20suspenseful%20mood%2C%20detailed%20environment&width=1600&height=900&seq=carousel-hero-03&orientation=landscape',
    tag: '推理专题',
  },
  {
    title: '奇幻异世界：打开想象力的无限大门',
    desc: '关于我转生变成史莱姆这档事、迷宫饭、无职转生——异世界题材漫画用天马行空的设定和细腻的世界观构建征服了无数读者。漫画全屏观看模式让异世界大陆的壮丽风景尽收眼底。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20style%20illustration%20of%20a%20grand%20magical%20world%20with%20floating%20castles%20ancient%20dragons%20and%20adventurers%20on%20a%20journey%2C%20warm%20golden%20and%20amber%20sky%2C%20Japanese%20anime%20art%20style%2C%20cinematic%20wide%20composition%2C%20rich%20environmental%20details%2C%20epic%20scale&width=1600&height=900&seq=carousel-hero-04&orientation=landscape',
    tag: '奇幻专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
            <i className="ri-sparkling-line text-accent-600 text-xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">焦点推荐</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {CAROUSEL_ITEMS.map((item, i) => (
            <article
              key={i}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  title={`${item.title} - 爱漫画网焦点推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="text-[10px] md:text-xs font-semibold text-background-50 bg-accent-500/85 px-3 py-1.5 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2.5">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
                <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">爱漫画网精选</span>
                  <span className="text-xs font-medium text-primary-600 group-hover:underline whitespace-nowrap">
                    查看专题 <i className="ri-arrow-right-line text-[10px] ml-0.5"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}